// Google Pay adapter implementing the WalletAdapter port.
//
// See adapters/apple-pay.js for the port contract.

function encodeBase64(str) {
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch (error) {
    return null;
  }
}

function extractWalletToken(event) {
  return encodeBase64(JSON.stringify(event));
}

function extractCardHolder(event) {
  return event?.paymentMethodData?.info?.billingAddress?.name;
}

function extractBillingData(config, event) {
  const billing = event?.paymentMethodData?.info?.billingAddress || {};
  const customerData = config?.customerData || {};

  return {
    firstName: customerData.firstName,
    lastName: customerData.lastName,
    customerNumber: customerData.customerNumber,
    billingEmail: customerData.billingEmail,
    billingAddress1: billing.address1,
    billingAddress2: billing.address2,
    billingCity: billing.locality,
    billingState: billing.administrativeArea,
    billingZip: billing.postalCode,
    billingCountry: billing.countryCode,
  };
}

export const googlePayAdapter = {
  walletType: "google_pay",
  extractWalletToken,
  extractCardHolder,
  extractBillingData,
};
